import React,{ useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import './attendanceBreaks.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { Dropdown } from 'react-bootstrap';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Card, CardImg, CardText, CardBody,CardHeader, Form, Table,
  CardTitle, CardSubtitle } from 'reactstrap';
import { var_api } from "../../constant";
import axios from "axios";
import jsPDF from "jspdf";
import Select from 'react-select';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Pagination from 'react-js-pagination';
import Loader from "../Loader";


const AttendanceBreaks = () => {

  const formatDate = (date) => {
    const d = new Date(date);
    const day = (`0${d.getDate()}`).slice(-2);
    const month = (`0${d.getMonth() + 1}`).slice(-2);
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
};

const parseDate = (dateString) => {
  const [day, month, year] = dateString.split('-');
  // Construct the date in the format yyyy-mm-dd
  return new Date(`${year}-${month}-${day}`);
};


    const history = useHistory();
    const shopname = localStorage.getItem('shopName');
    const today = new Date();
    const [viewMod, setViewMod] = useState(false);
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth() + 1; // Months are zero-based, so add 1
    const currentDay = today.getDate();
    const [todayIncome, setTodayIncome] = useState(null);
    const [monthlyIncome, setMonthlyIncome] = useState(null);
    const [ orders, setOrders ] = useState([]);
    const [buttonVisible, setButtonVisible] = useState(true);
    const [modal, setModal] = useState(false);
    const [employeesName, setEmployeesName] = useState(" ");
    const [employees, setEmployees] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [fromDate, setFromDate] = useState(formatDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1)));
    const [toDate, setToDate] = useState(formatDate(new Date()));
    const [data, setData] = useState([]);
    const [leavedata, setleaveData] = useState([]); // State variable to store the selected employee name
  const [totalWorkingHours, setTotalWorkingHours] = useState(0); // State variable to store total working hours
  const [totalLeave, setTotalLeave] = useState(0);
  const [totalbreakHours, setTotalbreakHours] = useState(0);
  const [rejectReason, setRejectReason] = useState('');
  const [currentItem, setCurrentItem] = useState(null);
  const [approvalStatus, setApprovalStatus] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; 
   const [totalItems, setTotalItems] = useState(0);
   const [ searchQuery,setSearchQuery] = useState('');
   const [startIndex, setStartIndex] = useState(0);
   const itemsPerPages = 10; 
   const [currentPages, setCurrentPages] = useState(1);
   const [totalItemss, setTotalItemss] = useState(0);
   const [ searchQuerys,setSearchQuerys] = useState('');
   const [startIndexs, setStartIndexs] = useState(0);
   const [isLoader, setIsLoader] = useState(false);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
};
const handlePageChanges = (pageNumber) => {
  setCurrentPages(pageNumber);
};
const handleSearchInput = (e) => {
  setSearchQuery(e.target.value)
  };
  const filteredOrders = Array.isArray(data) && data.filter((order)=> {
      const searchLower = searchQuery.toLowerCase();
      return(
          (order.task_date && order.task_date.toString().toLowerCase().includes(searchLower)) ||
          (order.total_working_time && order.total_working_time.toString().toLowerCase().includes(searchLower)) ||
          (order.total_break_time && order.total_break_time.toString().toLowerCase().includes(searchLower)) 
      )
  });
    //Navigate to home page
    const handleGoTOHome = () => {
        history.push('/sb-home');
    };

    useEffect(() => {
      let totalHours = 0;
      data.forEach(item => {
        totalHours += item.total_working_time;
      });
      setTotalWorkingHours(totalHours);

      let breakHours = 0;
      data.forEach(item => {
        breakHours += item.total_break_time;
      });
      setTotalbreakHours(breakHours);
  
      let totalLeaveDays = 0;
      leavedata.forEach(item => {
        totalLeaveDays += item.total_days;
      });
      setTotalLeave(totalLeaveDays);
    }, [data, leavedata]);

   //to handle view the report
   function handleViewReport(){
    setViewMod(true);
   }

   const toggle = () => setModal(!modal);


    useEffect(() => {
      getEmployees();
     }, [currentPage,currentPages,fromDate, toDate]);


     const getEmployees = () => {
      const token = localStorage.getItem('token');
      const headers = {
          Authorization: `${token}`
      };
  
      axios.get(`${var_api}/api/employee/shop-emp-details`, { headers })
          .then((response) => {
              const employeeData = response.data;
               // Filter out employees with the role 'Admin'
    const filteredEmployeeData = employeeData.filter(employee => employee.employee_role !== 'Admin');
              const employeeNames = filteredEmployeeData.map(employee => ({
                label: employee.name,
                value: employee.id
            }));
            setEmployees(employeeNames);
          if (employeeNames.length > 0) {
            const defaultEmployeeId = employeeNames[0].value;
            const defaultEmployeeName = employeeNames[0].label;
            setSelectedEmployee(defaultEmployeeId);
            setEmployeesName(defaultEmployeeName)
            getAttendancelist(defaultEmployeeId, fromDate, toDate);
            getLeavelist(defaultEmployeeId, fromDate, toDate); // Fetch the leave list for the first employee
        }
          })
          .catch((error) => {
              console.error('Error:', error);
              // Handle error
          });
  };
  
  // const handleEmployeeSelectChange = (selectedOption) => {
  //   setSelectedEmployee(selectedOption.value);
  //   getAttendancelist(selectedOption.value);
  //   getLeavelist(selectedOption.value);
  // };
  const handleEmployeeSelectChange = (selectedOption) => {
    setSelectedEmployee(selectedOption.value);
    setEmployeesName(selectedOption.label)
    getAttendancelist(selectedOption.value, fromDate, toDate);
    getLeavelist(selectedOption.value, fromDate, toDate); // Pass the employee ID to the getLeavelist function
};

      const getAttendancelist = (employeeId, fromDate, toDate) => {
        setIsLoader(true);
        const token = localStorage.getItem('token');
        const startIndexCalc = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndexCalc + itemsPerPage;
        const headers = {
            Authorization: `${token}`
        };

        axios.get(`${var_api}/api/attendance-list/${employeeId}/${fromDate}/${toDate}`, { headers })
            .then((response) => {
               console.log(response)
               const responseDate = response.data; 
               if (responseDate.length > 0) {
                setData(responseDate.slice(startIndexCalc, endIndex));
                  setTotalItems(responseDate.length);
                  setStartIndex(startIndexCalc); // Update startIndex state variable
              } else {
                  console.log('No data found.');
                  setData([]);
                  setTotalItems(0);
                  setStartIndex(0); // Reset startIndex state variable
              }
              setIsLoader(false);
              //  setData(responseDate);
            })
            .catch((error) => {
                console.error('Error:', error);
                // Handle error
                setIsLoader(false);
            });
    };
    
    const getLeavelist = (employeeId, fromDate, toDate) => {
      setIsLoader(true);
      const token = localStorage.getItem('token');
      const startIndexCalcs = (currentPages - 1) * itemsPerPages;
      const endIndexs = startIndexCalcs + itemsPerPages;
      const headers = {
          Authorization: `${token}`
      };
      axios.get(`${var_api}/api/leave-list/${employeeId}/${fromDate}/${toDate}`, { headers })
          .then((response) => {
             console.log(response)
             const responseDate = response.data; 
             if (responseDate.length > 0) {
              setleaveData(responseDate.slice(startIndexCalcs, endIndexs));
                setTotalItemss(responseDate.length);
                setStartIndexs(startIndexCalcs); // Update startIndex state variable
            } else {
                console.log('No data found.');
                setleaveData([]);
                setTotalItemss(0);
                setStartIndexs(0); // Reset startIndex state variable
            }
            //  setleaveData(responseDate);
            setIsLoader(false);
          })
          .catch((error) => {
              console.error('Error:', error);
              // Handle error
              setIsLoader(false)
          });
  };

  const handleRejectClick = (item) => {
    setCurrentItem(item);
    setApprovalStatus(2);  // Assuming 2 is the status for rejection
    setModal(true);
};

const handleConfirmClick = () => {
  if (currentItem) {
      putApproval(currentItem, approvalStatus, rejectReason);
      toggle();
  }
};

  
  const putApproval = (item, approvalStatus) => {
    const token = localStorage.getItem('token');
    const headers = {
        Authorization: `${token}`
    };

    const payload = {
        start_date: item.start_date,
        end_date: item.end_date,
        total_days: item.total_days,
        reason: item.reason,
        approval_status: approvalStatus,
        is_rejected_reason: rejectReason? rejectReason: '',
    };

    axios.put(`${var_api}/api/leave_request/put/${item.id}`, payload, { headers })
        .then((response) => {
            console.log(response);
            const responseData = response.data;
            getLeavelist(selectedEmployee, fromDate, toDate);
        })
        .catch((error) => {
            console.error('Error:', error);
            // Handle error
        });
};


  function getDayName(dateString) {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    // Split the date string into day, month, and year
    const parts = dateString.split("-");
    // Parse the date in mm-dd-yyyy format (JavaScript Date object expects mm-dd-yyyy or yyyy-mm-dd)
    const date = new Date(`${parts[1]}-${parts[0]}-${parts[2]}`);
    return days[date.getDay()];
}


 // Function to convert minutes to hours and minutes
 const convertMinutesToHours = (minutes) => {
  if (!minutes && minutes == 0) return "-"; 
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  if (hours > 0) {
    return `${hours} hrs ${remainingMinutes} mins`;
  } else {
    return `${remainingMinutes} mins`;
  }
};


    return (
     <>
      {isLoader && <Loader />}
    <div id="firdiv" style={{ backgroundColor: "white", fontFamily:"Arial, Helvetica, sans-serif"}}>
        <nav className="navbar  navbar-light py-2 sticky-top" style={{boxShadow: "0px 0px 1px 0px black",backgroundColor:"rgba(103, 120, 95)",border:"none",padding:"10px"}} >
            <h3 style={{textAlign:"center",color:"white"}} id="kifo"><i class="bi bi-person-fill-gear"></i>{" "}EMPLOYEE LOG AND LEAVE</h3>
            <button className="btn" style={{color:"rgba(103, 120, 95)", backgroundColor:"white"}} onClick={handleGoTOHome}><i class="bi bi-house"></i> Go to home</button>
        </nav>
        <br/>
        <div style={{padding:"15px"}}>


            <div style={{display: "flex", justifyContent: "space-between",width:"1100px",margin:"auto"}}>
            <div style={{ margin: "auto", width: "60%" }}>
  <div style={{ display: 'flex', alignItems: 'center', gap: "5px" }}>
    <label style={{fontWeight:"bolder",fontFamily:"serif",color: "rgba(103, 120, 95)"}}>Beautician: </label>
    <Select
            options={employees}
            value={employees.find(emp => emp.value === selectedEmployee)}
            onChange={handleEmployeeSelectChange}
            placeholder="Select an employee"
            isSearchable={true}
            styles={{
                menu: (provided) => ({
                    ...provided,
                    zIndex: 9999, // Ensure the dropdown is displayed above other elements
                    width: "300px"
                })
            }}
        />
    {/* <i className="bi bi-calendar text-primary" style={{ marginLeft: '5px', fontSize: "20px" }} ></i> */}
    
    <div className="card" style={{ width: "auto", margin: "0px", height: "auto", borderRadius: "10px" }}>
                <div className="card-body">
                    <div className="row">
                        <div className="col">
                            <label style={{ color: "rgba(103, 120, 95)" }}>From Date:</label>
                            <input
                                type="date"
                                placeholder="From time"
                                value={fromDate.split('-').reverse().join('-')}
                                onChange={(e) => setFromDate(e.target.value.split('-').reverse().join('-'))}
                            />
                        </div>
                        <div className="col">
                            <label style={{ color: "rgba(103, 120, 95)" }}>To Date:</label><br />
                            <input
                                type="date"
                                placeholder="To time"
                                value={toDate.split('-').reverse().join('-')}
                                onChange={(e) => setToDate(e.target.value.split('-').reverse().join('-'))}
                            />
                        </div>
                    </div>
                </div>
            </div>
  </div>
</div>

<div className="card " style={{ width: '350px', height:'auto',margin:"0px auto",backgroundColor:"white !important"}}>
    <div className="card-header" style={{textAlign:"center",fontWeight:"bolder",color: "rgba(103, 120, 95)"}}>Report Summary<br/><span style={{fontSize:"14px",color: "black"}}>{fromDate} to {toDate}</span></div>
    <div className="card-body" style={{padding:"10px",backgroundColor:"white", lineHeight:"8px"}}>
        <h6 style={{color: "rgba(103, 120, 95)",fontFamily:"serif",fontWeight:"bolder"}}>Beautician: <b style={{color:"black"}}>{employeesName}</b> </h6>
        <p style={{color: "rgba(103, 120, 95)",fontWeight:"bolder",fontFamily:"serif"}}>Total Working Hours: <b style={{color:"black"}}>{totalWorkingHours}</b></p>
        <p style={{color: "rgba(103, 120, 95)",fontWeight:"bolder",fontFamily:"serif"}}>Total Break Hours: <b style={{color:"black"}}>{totalbreakHours}</b></p> 
        <p style={{color: "rgba(103, 120, 95)",fontWeight:"bolder",fontFamily:"serif"}}>Total Leave Days: <b style={{color:"black"}}>{totalLeave}</b></p>  
    </div>
</div>
            </div>
            <br/>
            <br/>
            <Row>
              <Col xs={12} md={8} lg={6} xl={6} xxl={6}>
              <Card style={{width:'95%',height:'800px', padding:'10px', margin:'10px'}}>
              <h5 style={{color:"rgb(89, 128, 71)", fontWeight:"bold"}}>Employee Log
              {/* <span style={{float:"right", fontSize:"17px", color:"black", fontWeight:"bold"}}>
                <Form.Control type="text" placeholder="Search..."  onChange={handleSearchInput}/></span> */}
                </h5> 
                <div className="table-container" style={{ height: "800px", overflowX: 'auto', overflowY: 'scroll' }}>
                <table class="table table-hover small-first-col" style={{ border: "none", borderColor: "grey", fontFamily:"Arial, Helvetica, sans-serif"}}>
                    <thead>
                        <tr style={{ fontWeight: "bolder" }}>
                            <th scope="col">S.No</th>
                            <th scope="col">Date/Day</th>
                            <th scope="col">Working Hrs</th>
                            <th scope="col">Break Hrs</th>
                        </tr>
                    </thead>
                    <tbody className="body-half-screen">
        {filteredOrders.length > 0 ? (
        filteredOrders.map((item, index) => (
          <tr key={index} style={{ padding: "5px" }}>
            <td scope="row">{startIndex+index + 1}</td>
            <td>{item.task_date}<br />{getDayName(item.task_date)}</td>
            <td >{convertMinutesToHours(item.total_working_time)}</td>
            <td>{convertMinutesToHours(item.total_break_time)}</td>
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan="4" className="text-center">No data available</td>
        </tr>
      )}
      </tbody>
      </table>
      </div>
                <Pagination
    activePage={currentPage}
    itemsCountPerPage={itemsPerPage}
    totalItemsCount={totalItems} // Update to reflect total items for pagination
    pageRangeDisplayed={5}
    onChange={handlePageChange}
    itemClass="page-item"
    linkClass="page-link"
    innerClass="pagination justify-content-end"
    activeClass="active-pagination" // Custom class for the active pagination item
/>
              </Card>
              </Col>
              <Col xs={12} md={6} lg={6} xl={6} xxl={6} style={{padding:"0px",margin:"0px"}}>
              <Card style={{width:'95%',height:'800px', padding:'10px', margin:'10px'}}>
              <h5 style={{color:"rgb(89, 128, 71)", fontWeight:"bold"}}>Employee Leave </h5>  
              <div className="table-container" style={{ height: "800px", overflowX: 'auto', overflowY: 'scroll' }}>
              <table class="table table-hover small-first-col" style={{ border: "none", borderColor: "grey", fontFamily:"Arial, Helvetica, sans-serif"}}>
                    <thead>
                        <tr style={{ fontWeight: "bolder" }}>
                            <th scope="col">S.No</th>
                            <th scope="col">Date</th>
                            <th scope="col">Days</th>
                            <th scope="col">Reason</th>
                            <th scope="col">Status</th>
                        </tr>
                    </thead>
                    <tbody class="body-half-screen">
                    {leavedata.length > 0 ? (
                      leavedata.map((item, index) => (
          <tr key={index} style={{ padding: "5px" }}>
            <td scope="row">{startIndexs+index + 1}</td>
            <td>{`${item.start_date}`}/<br />{`${item.end_date}`}</td>
            <td>{`${item.total_days} days`}</td>
            <td>{item.reason}</td>
            <td>
            {item.approval_status === 0 ? (
        <>
            <button class="btn btn-success" style={{color:"white"}} onClick={() => putApproval(item, 1)}>Approve</button>
            <button class="btn btn-danger" style={{color:'white'}}  onClick={() => handleRejectClick(item)}>Reject</button>
        </>
    ) : (
        item.approval_status === 1 ? 
        <span className="badge rounded-pill bg-success p-2" style={{fontWeight:"normal"}}><i class="bi bi-check-circle-fill"></i>{" "}Approved</span>
         : <span className="badge rounded-pill bg-danger p-2" style={{fontWeight:"normal"}}><i class="bi bi-x-circle-fill"></i>{" "}Rejected</span>
    )}
            </td>          
            </tr>
        ))
      ): (
          <tr>
            <td colSpan="4" className="text-center">No data available</td>
          </tr>
        )}
                    </tbody>
                </table>
                </div>
                <Pagination
    activePage={currentPages}
    itemsCountPerPage={itemsPerPages}
    totalItemsCount={totalItemss} // Update to reflect total items for pagination
    pageRangeDisplayed={5}
    onChange={handlePageChanges}
    itemClass="page-item"
    linkClass="page-link"
    innerClass="pagination justify-content-end"
    activeClass="active-pagination" // Custom class for the active pagination item
/>
                
              </Card>
              </Col>
            </Row>
        </div>
        <Modal isOpen={modal} toggle={toggle}>
                <ModalHeader toggle={toggle}>Reject Reason</ModalHeader>
                <ModalBody>
                    <div className="col">
                        <label htmlFor="reject-reason">Reason</label>
                    </div>
                    <div className="col-md-6">
                        <textarea
                            id="reject-reason"
                            value={rejectReason}
                            onChange={(e) => setRejectReason(e.target.value)}
                            style={{width:'450px'}}
                        ></textarea>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="success" onClick={handleConfirmClick}>Confirm</Button>
                    <Button color="danger" onClick={toggle}>Close</Button>
                </ModalFooter>
            </Modal>
            {/* <Modal className="temp"
            size="lg"
            show={viewMod}
            onHide={handleCloseMod}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header closeButton>
              <Modal.Title> FINANCIAL REPORT</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ overflow: 'scroll' }}>
              
            </Modal.Body>
           
          </Modal>

        <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Break History</ModalHeader>
        <ModalBody>
          <div>
            <h6><b style={{color:"rgba(103, 120, 95)"}}>Date:</b> 16/05/2024 <span style={{float:"right"}}><b style={{color:"rgba(103, 120, 95)"}}>Day</b>: Thursday</span></h6>
            <h6><b style={{color:"rgba(103, 120, 95)"}}>Today Overall Break Time:</b>03:50 mins</h6>

            <div style={{maxHeight:"400px", marginTop:"25px", overflowY:"scroll"}}>
      <Card style={{padding:"5px", maxWidth:"22rem", height:"auto", margin:"auto" }}>
      <CardHeader>S.No:1</CardHeader>
        <CardBody>
          <CardText>
           
            <h6 style={{fontSize:"15px"}}><b>Break Start</b>: 11:00AM <span style={{float:"right"}}><b>Break End</b>: 11:30AM</span></h6>
            <h6 style={{fontSize:"15px"}}><b>Total Time</b>: 30mins</h6>
            <h6 style={{fontSize:"15px"}}><b>Reasons</b>: Personal Work </h6>
          </CardText>
        </CardBody>
      </Card>

      <Card style={{padding:"5px", maxWidth:"22rem", height:"auto", margin:"auto",marginTop:"10px" }}>
      <CardHeader>S.No:2</CardHeader>
        <CardBody>
          <CardText>
            <h6 style={{fontSize:"15px"}}><b>Break Start</b>: 01:00AM <span style={{float:"right"}}><b>Break End</b>: 2:30AM</span></h6>
            <h6 style={{fontSize:"15px"}}><b>Total Time</b>: 1hrs 30mins</h6>
            <h6 style={{fontSize:"15px"}}><b>Reasons</b>:Lunch Time </h6>
          </CardText>
        </CardBody>
      </Card>
      <Card style={{padding:"5px", maxWidth:"22rem", height:"auto", margin:"auto",marginTop:"10px" }}>
      <CardHeader>S.No:3</CardHeader>
        <CardBody>
          <CardText>
            <h6 style={{fontSize:"15px"}}><b>Break Start</b>: 03:00AM <span style={{float:"right"}}><b>Break End</b>: 03:30AM</span></h6>
            <h6 style={{fontSize:"15px"}}><b>Total Time</b>: 30mins</h6>
            <h6 style={{fontSize:"15px"}}><b>Reasons</b>: Personal Work</h6>
          </CardText>
        </CardBody>
      </Card>
      <Card style={{padding:"5px", maxWidth:"22rem", height:"auto", margin:"auto",marginTop:"10px" }}>
      <CardHeader>S.No:4</CardHeader>
        <CardBody>
          <CardText>
            <h6 style={{fontSize:"15px"}}><b>Break Start</b>: 05:00AM <span style={{float:"right"}}><b>Break End</b>: 06:30AM</span></h6>
            <h6 style={{fontSize:"15px"}}><b>Total Time</b>: 1hrs 20mins</h6>
            <h6 style={{fontSize:"15px"}}><b>Reasons</b>: Personal Work </h6>
          </CardText>
        </CardBody>
      </Card>
    </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={toggle}>Close</Button>
        </ModalFooter>
      </Modal> */}


            {/* <Modal className="temp"
            size="lg"
            show={viewMod}
            onHide={handleCloseMod}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header closeButton>
              <Modal.Title> FINANCIAL REPORT</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ overflow: 'scroll' }}>
              
            </Modal.Body>
           
          </Modal> */}

          
        
            
        </div>

     </>
  )
}





export default AttendanceBreaks;